// @flow
import React, { PureComponent } from 'react';
import EventsCard from 'components/event/EventsCard';

import type { EventPreviewType } from 'types/Event';
import type { Status } from 'types/Status';
import type { Props as OwnProps } from 'components/event/EventsCard';

export type { OwnProps };
export type StateProps = {
  events: Array<EventPreviewType>,
  status: Status
};

export type DispatchProps = {
  fetchEvents: () => void
};

type Props = OwnProps & StateProps & DispatchProps;

class DynamicEventsCard extends PureComponent<Props> {
  componentDidMount() {
    this.props.fetchEvents();
  }

  render() {
    const { fetchEvents: _fetchEvents, status: _status, ...others } = this.props;
    return <EventsCard {...others} />;
  }
}

export default DynamicEventsCard;
